import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Button, Checkbox, IconButton, Tooltip } from "@mui/material";
import { useAsignaturas } from "../../../../context/SuperAdmin/OASContexts/AsignaturasContext";
import { iDataAsignatura } from "../../../../interfaces/SuperAdmin/Pages/iDataAsignatura";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../../utils/dateFunctions";

interface Props {
  asignatura: iDataAsignatura;
  i: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const AsignaturasRow: React.FC<Props> = ({
  asignatura,
  i,
  isSelected,
  handleSelect,
}) => {
  const { nombre, created_at } = asignatura;
  const { handleEditAsignatura } = useAsignaturas();

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(asignatura.id_asignatura)}
        />
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center", maxWidth: 400 }}>
        {nombre}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {formatFechaWithHour(created_at)}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        <Button
          sx={{ color: "#336B87" }}
          onClick={() => handleEditAsignatura(asignatura)}
        >
          <Tooltip title="Editar asignatura">
            <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
              <EditOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};
